var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingGray5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 1.5H1V36.5H36V1.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2979 21.0293C27.2979 21.9961 27.1045 22.963 26.8144 23.8332C25.6542 27.3138 22.3669 29.8276 18.4995 29.8276C14.6321 29.8276 11.3448 27.3138 10.1846 23.8332C9.89454 22.963 9.70117 21.9961 9.70117 21.0293H27.2979Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5.6693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3388 6.74644C17.4355 8.2934 16.8554 11.3873 12.8913 14.868C7.67027 14.1912 5.54319 11.8707 4.76971 10.5172C4.47966 10.0337 4.38298 9.74367 4.38298 9.64699C3.89955 7.90666 4.86641 5.97296 6.60674 5.48953C8.34707 5.00611 10.2808 5.97296 10.7642 7.71329C10.2808 5.97296 11.2476 4.03925 12.9879 3.55583C14.7283 3.0724 16.662 4.03925 17.1454 5.77959C17.2421 5.77959 17.3388 6.16633 17.3388 6.74644Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6599 6.74644C19.5632 8.2934 20.1433 11.3873 24.1074 14.868C29.3284 14.1912 31.4555 11.8707 32.229 10.5172C32.519 10.0337 32.6157 9.74367 32.6157 9.64699C33.0992 7.90666 32.1323 5.97296 30.392 5.48953C28.6516 5.00611 26.7179 5.97296 26.2345 7.71329C26.7179 5.97296 25.7511 4.03925 24.0108 3.55583C22.2704 3.0724 20.3367 4.03925 19.8533 5.77959C19.7566 5.77959 19.6599 6.16633 19.6599 6.74644Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2979 21.0293C27.2979 21.9961 27.1045 22.963 26.8144 23.8332H10.1846C9.89454 22.963 9.70117 21.9961 9.70117 21.0293H27.2979Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGray5);
export default __webpack_public_path__ + "static/media/rating-gray-5.664a6fef250cd532e0b3c8b5ffe5894c.svg";
export { ForwardRef as ReactComponent };